// filename: map.js


var mapPin = siteSettings.templateUri + "/assets/images/map-pin.png";

var loaded = false,
	loading = false,
	callbacks = [];

var isDraggable = $(document).width() > 480 ? true : false;

var defaultMapOptions = {
	zoom: 8,
    draggable: isDraggable,

    // control options
    panControl : false, // left right up down circle
    scrollwheel: false, // scrollwheel zoom
    zoomControl : true, // + - controls
    streetViewControl : true,
    mapTypeControl: false,
    overviewMapControl: false,
    blackAndWhite: [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]
};

var geocoder = false;
var region = 'uk';


function async(u, c) {
  var d = document, t = 'script',
      o = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
  o.src = u;
  if (c) { o.addEventListener('load', function (e) { c(null, e); }, false); }
  s.parentNode.insertBefore(o, s);
}


function loadMapsScript(callback) {

	// if callback exists and youtube is already loaded, 
	// run callback straight away
	if (callback && loaded) {
		callback();
		return;
	}

	// we're about to load / still loading
	// run the callback later
	if (callback) {
		callbacks.push(callback);
	}

	// load it!
	if (!loading && !loaded) {
		loading = true;


		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAVnip779BS36uxIt-cFCyIFcYEHdRYYqA&callback=googlemapInitialize';
		document.body.appendChild(script);

		window.googlemapInitialize = function() {

			// init google funcs
			geocoder = new google.maps.Geocoder();

			loading = false;
			loaded = true;

			for (var i = 0; i < callbacks.length; i++) {
				callbacks[i](); // run callbacks
			};
		}
	}
}

function load(callback) {
	loadMapsScript(function() {
		async(siteSettings.templateUri + '/assets/js/vendor/markerwithlabel_packed.js', callback);
	});
}

function geocodeString(string, callbacks = {}) {

	var args = {
		address : string,
		region : region,
		// componentRestrictions: {
		//   country: 'UK'
		// }
	}

	geocoder.geocode(args, function(results, status) {

		if (status == google.maps.GeocoderStatus.OK) {
			if (callbacks.success) {

				var sortedResults = geocodeResultSort(results);

				callbacks.success(sortedResults, results);
			}
		} else {
			if (callbacks.error) {
				callbacks.error(status);
			}
		}
	});
}


function geocodeResultSort(results) {

	var r = [];

	if (!results.length) {
		return false;
	}

	var result = results[0];

	if (result.partial_match) {
		return false;
	}

	var address_components = result.address_components;

	var components = {}; 

	jQuery.each(address_components, function(k,v1) {
		jQuery.each(v1.types, function(k2, v2){
			components[v2]=v1.long_name
		});
	});

	var shortAddress = [];

	shortAddress.push(components.neighborhood || components.locality || '');
	shortAddress.push(components.postal_town || components.administrative_area_level_2);
	if (components.postal_code) {
		shortAddress[1] = shortAddress[1] + ' ' + components.postal_code;
	}
	shortAddress = shortAddress.join(', ');

	var lat = result.geometry.location.lat();
	var lng = result.geometry.location.lng();
	var address = result.formatted_address;

	return {
		lat, lng, address, components, shortAddress
	}
}

function init() {}

export default {
	init : init,
	load : load,
	geocodeString : geocodeString,
	defaultMapOptions : function() {
		return defaultMapOptions;
	},
	mapPin : function() {
		return mapPin;
	}
}